module.exports = __webpack_public_path__ + "img/2.906d9ade.png";